import { DISPLAY_ALERT, REMOVE_ALERT } from "../actiontypes";

export const displayAlert = (data) => {
  return {
    type: DISPLAY_ALERT,
    data,
  };
};
